import React from 'react';
import _ from 'lodash';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { Button, Checkbox, Divider, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import toast from 'react-hot-toast';
import { useMutation, useParameterizedQuery } from 'react-fetching-library';
import DeleteIcon from '@mui/icons-material/Delete';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import AttachEmailIcon from '@mui/icons-material/AttachEmail';

import { downloadCheckboxSectionFileAction, sendAgreementsToDGCSAction, uploadCheckboxSectionFileAction } from '../../../../../../services/request';
import PDFPreviewModal from './PDFPreviewModal';
import DocumentForm from '../../../../../staff/personal-documents/DocumentForm';
import CheckboxSectionForm from './additional-documents/CheckboxSectionForm';
import { useApplication } from '../../../ApplicationsContext';
import SendMessagePreviewModal from './SendMessagePreviewModal';

export const DocumentCheckboxes = ({ formik }) => {
  const { rowData, choices, setRowData } = useApplication();
  const { query } = useParameterizedQuery(downloadCheckboxSectionFileAction);
  const uploadFileMutation = useMutation(uploadCheckboxSectionFileAction);
  const sendDocumentMutation = useMutation(sendAgreementsToDGCSAction);
  const [previewUrl, setPreviewUrl] = React.useState(null);
  const [openAddDocument, setOpenAddDocument] = React.useState(false);
  const [openAddCheckboxSection, setOpenAddCheckboxSection] = React.useState(false);
  const [selectedCheckboxSectionId, setSelectedCheckboxSectionId] = React.useState(false);
  const [usedCategories, setUsedCategories] = React.useState([]);
  const [previewModalData, setPreviewModalData] = React.useState({ handleSend: () => { }, type: '', fileNames: [] });
  const [openPreviewModal, setOpenPreviewModal] = React.useState(false);

  const handleChange = (checkboxId, sectionId) => {
    const cloneSections = _.cloneDeep(formik.values.checkbox_sections);
    const section = _.filter(
      cloneSections,
      section => section.id === sectionId
    )[0];
    const index = cloneSections.indexOf(section);
    cloneSections.splice(index, 1);

    const cbox = _.filter(section.items, item => item.id === checkboxId)[0];
    const cboxIndex = section.items.indexOf(cbox);
    section.items.splice(cboxIndex, 1);
    cbox.value = !cbox.value;
    section.items.splice(cboxIndex, 0, cbox);
    if (cbox.name == 'odrzucone' && cbox.value) {
      const returnedCbox = section.items.find(ci => ci.name == 'zwrócone');
      if (returnedCbox) {
        const returnedCboxIndex = section.items.indexOf(returnedCbox);
        section.items.splice(returnedCboxIndex, 1);
        returnedCbox.value = false;
        section.items.splice(returnedCboxIndex, 0, returnedCbox);
      }
    }

    cloneSections.splice(index, 0, section);
    formik.setFieldValue('checkbox_sections', cloneSections);
  };

  const handleDownload = async (row, preview = false) => {
    console.log(row);
    const { payload, error, loading } = await query(row.id);

    if (!error) {
      if (preview) {
        setPreviewUrl(window.URL.createObjectURL(payload));
      } else {
        const url = window.URL.createObjectURL(payload);
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.style = 'display: none';
        a.href = url;
        a.download = `${row.file_name}`;
        a.click();
        window.URL.revokeObjectURL(url);
      }
    } else {
      toast.error('Nie udało się pobrać pliku');
    }
  };

  const handleDelete = id => {
    const newSections = formik.values.checkbox_sections.map(cs => cs.id == id ? { ...cs, file: null, file_name: null } : cs);
    formik.setFieldValue('checkbox_sections', newSections);
  };

  const handleUpload = checkboxSectionId => {
    setSelectedCheckboxSectionId(checkboxSectionId);
    setOpenAddDocument(true);
  };

  const uploadCheckboxSectionFile = async (checkboxSectionId, formData) => {
    formData.append('new_document_added_by_office', true);
    const { error, payload } = await uploadFileMutation.mutate(formData, checkboxSectionId);

    if (!error) {
      const newSections = formik.values.checkbox_sections.map(cs => cs.id == payload.id ? payload : cs);
      setTimeout(() => {
        formik.setValues({ ...formik.values, checkbox_sections: newSections });
      }, 0);
      formik.resetForm({
        values: { ...formik.values, checkbox_sections: newSections }
      });


      return true;
    }

    return false;
  };

  const handleAddCheckboxSection = newSection => {
    // TODO to nie działa tak jak powinno, formik nie restartuje się poprawnie
    const newSections = [...formik.values.checkbox_sections, newSection];
    setTimeout(() => {
      formik.setValues({ ...formik.values, checkbox_sections: newSections });
    }, 0);
    formik.resetForm({
      values: { ...formik.values, checkbox_sections: newSections }
    });

  };

  const handleOpenPreviewModal = (handleSend, type, fileNames) => {
    setPreviewModalData({ handleSend, type, fileNames });
    setOpenPreviewModal(true);
  };

  const handleClosePreviewModal = () => {
    setOpenPreviewModal(false);
    setPreviewModalData({ handleSend: () => { }, type: '', fileNames: [] });
  };

  const handleSendDocument = async data => {
    if (data.notification_type === 'SPID') {
      data.only_pit = true;
    }
    if (data.notification_type === 'SPPD') {
      data.only_ppk = true;
    }
    data.id_list = [rowData.id];
    const { error, loading } = await sendDocumentMutation.mutate(data);
    if (!error && !loading) {
      toast.success('Email został wysłany');
      if (data.only_pit) {
        setRowData(prev => ({ ...prev, pit_document_sent_at: new Date() }));
      }
      if (data.only_ppk) {
        setRowData(prev => ({ ...prev, ppk_document_sent_at: new Date() }));
      }
      setOpenPreviewModal(false);

    }

    if (error) {
      toast.error('Nie udało się wysłać dokumentu');
    }
  };

  React.useEffect(() => {
    setUsedCategories(formik.values.checkbox_sections.filter(cs => cs.category != 6).map(cs => cs.category));

  }, [formik.values.checkbox_sections]);

  const Component = ({ key, sections, type, typeSuffix = '', canAddSection = false, handleOpenPreviewModalCallback = undefined }) => (
    <Stack direction="column" justifyContent="center" alignItems="left" key={key}>
      <Stack direction="row" mt={1} mb={1}>
        <Typography color="green" sx={{ p: 1 }}>
          {type} dokumenty {typeSuffix}
        </Typography>
        {canAddSection &&
          <Button variant="contained" size="small" onClick={() => setOpenAddCheckboxSection(true)}>
              Dodaj Dokument
          </Button>
        }
      </Stack>
      {_.map(sections, (section, key) => (
        <div key={key}>
          <Divider flexItem />
          <Stack
            direction="row"
            key={key}
            alignItems="center"
            justifyContent="center"
          >
            <Stack flex="1 1 80%">
              <Typography variant="caption">
                {typeSuffix
                  ? <Tooltip title={section.file_description}><b>{section.document_name} ({section.category_display})</b></Tooltip>
                  : <b>{section.name}</b>}
              </Typography>
            </Stack>
            <Divider orientation="vertical" flexItem sx={{ ml: 1, mr: 1 }} />
            <Stack direction="row" flex="1 1 20%">
              {_.map(section.items, (item, key) => (
                <>
                  {!(item.name == 'wysłane' && ([
                    'UMOWA',
                    'KWESTIONARIUSZ',
                    'OŚWIADCZENIE STUDENTA'
                  ].includes(section.name) ||
                        section.name.startsWith('ANEKS'))) && <Stack direction="row" alignItems="center" key={key}>
                    <Typography variant="caption">{item.name}</Typography>
                    <Checkbox
                      disabled={
                        item.value &&
                      item.name == 'zwrócone' &&
                      ([
                        'UMOWA',
                        'KWESTIONARIUSZ',
                        'OŚWIADCZENIE STUDENTA'
                      ].includes(section.name) ||
                        section.name.startsWith('ANEKS'))
                      }
                      onChange={() => handleChange(item.id, section.id)}
                      checked={item.value}
                    />
                  </Stack>}</>
              ))}
              <Divider orientation="vertical" flexItem sx={{ ml: 1, mr: 1 }} />
              {section.file ? <Stack>
                <Stack direction="row" spacing={0.5}>
                  {section.can_preview && <Tooltip title="Pokaż">
                    <IconButton onClick={() => handleDownload(section, true)}>
                      <RemoveRedEyeIcon color="primary" />
                    </IconButton>
                  </Tooltip>}
                  <Tooltip title="Pobierz Plik" onClick={() => handleDownload(section)}>
                    <IconButton color="info">
                      <FileDownloadIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Usuń" onClick={() => handleDelete(section.id)}>
                    <IconButton
                      color="error"
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Tooltip>
                  {section.name.includes('INFORMACJA O PPK') && <Stack>
                    {rowData.ppk_document_sent_at
                      ? <Tooltip title="Dokument wysłany do DGCS">
                        <span>
                          <IconButton color="primary" disabled>
                            <AttachEmailIcon/>
                          </IconButton>
                        </span>
                      </Tooltip>
                      : <Tooltip title="Wyślij do DGCS...">
                        <IconButton color="secondary" onClick={() => handleOpenPreviewModalCallback(handleSendDocument, 'SPPD', [` Informacja o PPK - ${rowData.name} ${rowData.surname}`])}>
                          <AttachEmailIcon />
                        </IconButton>
                      </Tooltip>
                    }
                  </Stack>}
                  {section.name.includes('REZYGNACJA PPK') && <Stack>
                    {rowData.ppk_document_sent_at
                      ? <Tooltip title="Dokument wysłany do DGCS">
                        <span>
                          <IconButton color="primary" disabled>
                            <AttachEmailIcon/>
                          </IconButton>
                        </span>
                      </Tooltip>
                      : <Tooltip title="Wyślij do DGCS...">
                        <IconButton color="secondary" onClick={() => handleOpenPreviewModalCallback(handleSendDocument, 'SPPD', [` Rezygnacja PPK - ${rowData.name} ${rowData.surname}`])}>
                          <AttachEmailIcon />
                        </IconButton>
                      </Tooltip>
                    }
                  </Stack>}
                  {section.name.includes('PIT') && <Stack>
                    {rowData.pit_document_sent_at
                      ? <Tooltip title="Dokument wysłany do DGCS">
                        <span>
                          <IconButton color="primary" disabled>
                            <AttachEmailIcon/>
                          </IconButton>
                        </span>
                      </Tooltip>
                      : <Tooltip title="Wyślij do DGCS...">
                        <IconButton color="secondary" onClick={() => handleOpenPreviewModalCallback(handleSendDocument, 'SPID', [`Oświadczenie PIT - ${rowData.name} ${rowData.surname}`])}>
                          <AttachEmailIcon />
                        </IconButton>
                      </Tooltip>
                    }
                  </Stack>}
                </Stack></Stack>
                : !([
                  'UMOWA',
                  'KWESTIONARIUSZ',
                  'OŚWIADCZENIE STUDENTA'
                ].includes(section.name) ||
                section.name.startsWith('ANEKS')) && <Stack>
                  <Tooltip title="Wgraj Plik...">
                    <IconButton onClick={() => handleUpload(section.id)}><UploadFileIcon color="primary" /></IconButton>
                  </Tooltip>
                </Stack>}
            </Stack>
          </Stack>
        </div>
      ))}
    </Stack>
  );

  return (
    <Stack direction="column">
      <Component
        key={1}
        sections={_.filter(
          formik.values.checkbox_sections,
          s => s.section_type === 'podstawowe'
        )}
        handleOpenPreviewModalCallback={handleOpenPreviewModal}
        type="Podstawowe"
      />
      <Divider flexItem />
      <Component
        key={2}
        sections={_.filter(
          formik.values.checkbox_sections,
          s => s.section_type === 'dodatkowe'
        )}
        type="Dodatkowe"
      />
      <Divider flexItem />
      <Component
        key={3}
        sections={_.filter(
          formik.values.checkbox_sections,
          s => s.section_type === 'dodatkowe dokumenty personalne dodane przez pracownika'
        )}
        type="Dodatkowe"
        typeSuffix="personalne dodane przez pracownika"
      />
      <Divider flexItem />
      <Component
        key={4}
        sections={_.filter(
          formik.values.checkbox_sections,
          s => s.section_type === 'dodatkowe dokumenty personalne dodane przez biuro'
        )}
        type="Dodatkowe"
        typeSuffix="personalne dodane przez biuro"
        canAddSection={true}
      />
      {previewUrl !== null ? <PDFPreviewModal url={previewUrl} handleClose={() => setPreviewUrl(null)}/> : null}
      {openAddDocument && <DocumentForm
        open={openAddDocument}
        handleClose={() => setOpenAddDocument(false)}
        checkboxSectionId={selectedCheckboxSectionId}
        uploadCheckboxSectionFile={uploadCheckboxSectionFile}
        officeView={true}
      />}
      {openAddCheckboxSection && <CheckboxSectionForm
        open={openAddCheckboxSection}
        handleClose={() => setOpenAddCheckboxSection(false)}
        handleAddCheckboxSection={handleAddCheckboxSection}
        rowData={rowData}
        categories={choices.checkbox_section_categories.filter(csc => !usedCategories.includes(csc.value))}
        officeView={true}
      />}
      <Divider flexItem />
      {openPreviewModal && <SendMessagePreviewModal
        handleSend={previewModalData.handleSend}
        handleClose={handleClosePreviewModal}
        fileNames={previewModalData.fileNames}
        type={previewModalData.type} />
      }
    </Stack>
  );
};
